module.exports = __webpack_public_path__ + "media/images/arrow-next-5d27683c06d3f964b65e67d7c58221e0.svg";